import { SVGProps } from 'react'

export const NeImageErrorSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 18 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='none' fillRule='evenodd' id='页面-2' stroke='none' strokeWidth='1'>
      <g id='其他卡片' transform='translate(-831.000000, -7078.000000)'>
        <g id='编组-10' transform='translate(729.000000, 7032.000000)'>
          <g id='编组-15' transform='translate(102.000000, 46.000000)'>
            <g id='image备份'>
              <rect
                fill='#000000'
                fillRule='nonzero'
                height='16'
                id='矩形'
                opacity='0'
                width='16'
                x='0'
                y='0'
              />
              <path
                d='M2.125,12.375 L2.125,10.4960156 L4.194125,8.042375 C4.24407812,7.98315625 4.33529688,7.98315625 4.38525,8.042375 L6.63471875,10.7098437 L10.1869531,6.49754687 C10.2369063,6.43832812 10.328125,6.43832812 10.3780781,6.49754687 L13.875,10.64425 L13.875,12.375 L13.875,3.625 L2.125,3.625 L2.125,12.375 Z M1.5,2.5 L14.5,2.5 C14.7761406,2.5 15,2.72385937 15,3 L15,13 C15,13.2761406 14.7761406,13.5 14.5,13.5 L1.5,13.5 C1.22385937,13.5 1,13.2761406 1,13 L1,3 C1,2.72385937 1.22385937,2.5 1.5,2.5 Z M4.75,7 C4.05964063,7 3.5,6.44035937 3.5,5.75 C3.5,5.05964063 4.05964063,4.5 4.75,4.5 C5.44035937,4.5 6,5.05964063 6,5.75 C6,6.44035937 5.44035937,7 4.75,7 Z'
                fill='#8C8C8C'
                id='形状'
              />
            </g>
            <g id='alert-fill' transform='translate(9.000000, 7.000000)'>
              <path
                d='M4.870227,0.216197695 L8.94272401,7.35134981 C9.01909103,7.48514349 9.01909206,7.64998385 8.94272672,7.78377851 C8.86636138,7.91757317 8.72523106,8 8.57249701,8 L0.427502991,8 C0.274768942,8 0.133638625,7.91757317 0.0572732809,7.78377851 C-0.0190920629,7.64998385 -0.0190910287,7.48514349 0.0572759941,7.35134981 L4.129773,0.216197695 C4.20614384,0.0824130438 4.34727177,0 4.5,0 C4.65272823,0 4.79385616,0.0824130438 4.870227,0.216197695 Z'
                fill='#F7D844'
                id='形状'
              />
              <polygon
                fill='#FFFFFF'
                id='路径'
                points='4.07248614 5.8378327 4.07248614 6.70269962 4.92751386 6.70269962 4.92751386 5.8378327'
              />
              <polygon
                fill='#FFFFFF'
                id='路径'
                points='4.07248614 2.81079846 4.07248614 4.97296577 4.92751386 4.97296577 4.92751386 2.81079846 4.07248614 2.81079846'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
